import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseValidationResult } from "@ha/ui/forms";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PermitPerson } from "../models/permit-person.model";
import { PermitRequestCandidate } from "../models/permit-request-candidate.model";
import { PermitRequest } from "../models/permit-request.model";
import { PermitToSign } from "../models/permit-to-sign.model";
import { RequestPermitCommand } from "../models/request-permit-command.model";

interface CurrentUserStateModel {
    currentUser: { currentUser: CurrentUser; };
}

interface CurrentUser {
    isHotworker: boolean;
    canCreateDemoPermits: boolean;
    isExternal: boolean;
    isAdministrator: boolean;
}

@Injectable({ providedIn: "root" })
export class PermitUserService {
    constructor(private httpClient: HttpClient, private store: Store) {}

    public get currentUser(): CurrentUser {
        return this.store.selectSnapshot<CurrentUser>((_: CurrentUserStateModel) => _.currentUser.currentUser);
    }

    public getCurrentPerson(): Observable<PermitPerson> {
        return this.httpClient.get<PermitPerson>("/api/PermitPerson/GetCurrentPerson");
    }

    public getPermitsToSign(): Observable<PermitToSign[]> {
        return this.httpClient.get<PermitToSign[]>("/api/PermitPerson/GetPermitsToSign");
    }

    public getPermitRequests(): Observable<PermitRequest[]> {
        return this.httpClient.get<PermitRequest[]>("/api/PermitPerson/GetPermitRequests");
    }

    public getPermitRequestCandidates(permitId: number): Observable<PermitRequestCandidate[]> {
        return this.httpClient.get<PermitRequestCandidate[]>("/api/PermitPerson/GetPermitRequestCandidates", {
            params: { permitId: permitId },
        });
    }

    public requestPermit(command: RequestPermitCommand): Observable<BaseValidationResult> {
        return this.httpClient.post<BaseValidationResult>("/api/Permit/RequestPermit", command);
    }
}
